import Styled, { css } from "styled-components";
import media from "../../utils/media";

const Viewer = Styled.section`
  background: ${props => props.theme.background};
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin-top: 72px; // AppBar

  ${media.desktop`
    border-radius: 2px;
    margin: auto;
    width: 86%;
    max-width: calc(14rem + 65ch);
    box-sizing: border-box;
    position: relative;
    ${props =>
      props.wide &&
      css`
        max-width: calc(14rem + ${(props.numOfParallels + 1) * 65}ch);
        width: 100%;
      `};
  `};
`;
export default Viewer;
